import { object, string } from 'yup'

export default object({
  email: string().email(),
})
